import type { ICSRFResponse, IGUJResponse } from "@litres-libs/types";

interface IParseGUAjaxJSON {
  <TData>(html: unknown): ICSRFResponse<TData> | null;
  <TData>(html: unknown): IGUJResponse<TData> | null;
}

export const parseGUAjaxJSONfromHTML: IParseGUAjaxJSON = <
  TPayload extends object,
>(
  html: unknown
) => {
  let responseJson = {};

  // Если пришла строка - парсим ее и ищем ответ
  if (typeof html === "string") {
    const isGUAjax = html.indexOf("var GUAjaxData") !== -1;
    const isSimulatedGUAjax = html.indexOf("var SimulatedGUAjaxData") !== -1;

    // Парсинг стандартного GUAjax
    if (isGUAjax) {
      // Парсим JSON ответ из html
      const dataString = html.toString();
      const firstBrace = isGUAjax
        ? dataString.indexOf("var GUAjaxData") + 17
        : dataString.indexOf("{");
      const lastBrace = dataString.lastIndexOf("}") + 1;

      // Проверим есть ли вообще строка var GUAjaxData, если нет - это не ответ GUJ
      if (firstBrace <= 0) {
        if (!isGUAjax) {
          return null;
        }
      }

      const responseJsonString = dataString.slice(firstBrace, lastBrace);

      try {
        responseJson = JSON.parse(responseJsonString);
      } catch (error) {
        console.error("GUJ/CSRF Parsing Error: ", error);
      }
    }

    // Парсинг GUAjax, собранного версткой из xml+xslt
    if (isSimulatedGUAjax) {
      // Парсим JSON ответ из html
      const dataString = html.toString();
      const firstBrace = dataString.indexOf("var SimulatedGUAjaxData") + 26;
      const lastBrace = dataString.lastIndexOf("};//EOF") + 1;

      if (firstBrace <= 0) {
        return null;
      }

      const responseJsonString = dataString.slice(firstBrace, lastBrace);

      try {
        responseJson = eval(`(${responseJsonString})`);
      } catch (error) {
        console.error("GUJ/CSRF(Simulated) Parsing Error: ", error);
      }
    }
  }

  // Если передали объект - значит в ответе был просто JSON, например запрос поиска
  if (typeof html === "object") {
    responseJson = html as unknown as TPayload;
  }

  return responseJson as TPayload;
};
